<template>
  <div>
    <el-table
      :data="customers"
      border
      fit
      stripe
      lazy
      style="width: 100%"
      v-loading="loading"
      ref="table"
      class="table-box card-base card-shadow--medium"
      max-height="550"
    >
      <el-table-column
        prop="Id"
        label="NO"
        column-key="Id"
        sortable
        width="80"
      />
      <el-table-column
        label="Documento"
        prop="DocumentNo"
        column-key="DocumentNo"
        sortable
        width="135"
      />
      <el-table-column
        label="Nombre"
        sort-by="Name"
        column-key="Name"
        prop="Name"
        sortable
      />
      <el-table-column
        label="Email"
        sort-by="Email"
        column-key="Email"
        prop="Email"
        sortable
        width="250"
      />
      <el-table-column
        label="Dirección"
        sort-by="Address"
        column-key="Address"
        prop="Address"
        sortable
      />
      <el-table-column
        label="Teléfono"
        sort-by="PhoneNumber"
        column-key="PhoneNumber"
        prop="PhoneNumber"
        sortable
        width="115"
      />
      <el-table-column
        label="Contacto"
        sort-by="ContactName"
        column-key="ContactName"
        prop="ContactName"
        sortable
        width="120"
      />
      <el-table-column
        label="Lotes"
        sort-by="Batches"
        column-key="Batches"
        prop="Batches"
        sortable
        width="90"
      />
    </el-table>

    <el-pagination
      :hide-on-single-page="pagination.currentPage <= 1"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="pagination.total"
      style="margin-top: 20px"
    />
  </div>
</template>

<script>
export default {
  name: "CustomerList",
  data() {
    return {
      activeName: "",
      accountNumber: 11030100,
      pagination: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      loading: false,
      departmentId: 2,
      productId: 0,
      serviceRequestTypeId: 0,
      technicalId: 0,
      customers: []
    };
  },
  methods: {
    getData() {
      this.loading = true;

      const url = "/api/workshopcustomer/All";

      this.$http
        .get(url)
        .then((resp) => {
          this.loading = false;
          this.customers = resp.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getData();
    },
    formatDate(date, toFormat = "DD/MM/YYYY hh:mm:ss") {
      // date => "2020-06-25T10:54:07.28" or "2020-06-25T10:54:07.280"
      let format = "YYYY-MM-DDTHH:mm:ss.SS";

      if (date.length === 23) {
        format = "YYYY-MM-DDTHH:mm:ss.SSS";
      }
      let mDate = this.$moment(date, format);

      if (mDate.isValid()) {
        return mDate.format(toFormat);
      }
      return "";
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style>
.el-dropdown-link {
  cursor: pointer;
  color: #3c3c3c;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
